import { useEffect } from "react";
import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";
import { useNewUpdates } from "@/v2/hooks/useNewUpdates";

export default function Updates() {
  useDocumentTitle("Updates");
  const { markSeen } = useNewUpdates();

  useEffect(() => {
    markSeen();
  }, [markSeen]);

  return (
    <div className="p-4">
      <h1 className="text-lg mb-6">Updates</h1>
      <div className="space-y-4">
        <div className="h-32 rounded-lg bg-muted animate-pulse" />
        <div className="h-32 rounded-lg bg-muted animate-pulse" />
      </div>
    </div>
  );
}
